import { render } from "./RegistrosDePonto.vue?vue&type=template&id=8c9539c8"
import script from "./RegistrosDePonto.vue?vue&type=script&lang=js"
export * from "./RegistrosDePonto.vue?vue&type=script&lang=js"

import "./RegistrosDePonto.vue?vue&type=style&index=0&id=8c9539c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__